export const CloudWatchEventTypes = {
  PAGE_VISIT: 'page_visit',
  USER_ACTION: 'user_action',
  SECTION_DURATION: 'section_duration',
  TOTAL_TIME_SPENT: 'total_time_spent',
  SECTION_VIEWED: 'section_viewed'
} as const;

export const CLOUDWATCH_REGION = 'ap-south-1';
export const CLOUDWATCH_LOG_STREAM_NAME = 'events';

export const CloudWatchEventNames = {
  // Personal Details Section
  DISCOUNT_POPUP_VISITED: 'discount_popup_visited',
  DISCOUNT_POPUP_COPIED: 'discount_popup_copied',
  DISCOUNT_POPUP_DISMISSED: 'discount_popup_dismissed',
  DISCOUNT_POPUP_APPLIED: 'discount_popup_applied',
  PERSONAL_DETAILS_PAGE_VISIT: 'personal_details_page_visit',
  PARENT_FLOW_STUDENT_NUMBER_GET_OTP: 'parent_flow_student_number_get_otp',
  PARENT_FLOW_STUDENT_NUMBER_VERIFIED: 'parent_flow_student_number_verified',
  PERSONAL_DETAILS_PAGE_COMPLETED: 'personal_details_page_completed',
  PERSONAL_DETAILS_SECTION_CLICKED: 'personal_details_section_clicked',
  NIAT_OFFLINE_PERSONAL_DETAILS_PENDING_POPUP_VIEWED:
    'niat_offline_personal_details_pending_popup_viewed',
  NIAT_OFFLINE_PERSONAL_DETAILS_PENDING_POPUP_CTA_CLICKED:
    'niat_offline_personal_details_pending_popup_cta_clicked',

  // Payment Section
  BOOK_ADMISSION_TEST_FEE_PAGE_VISIT: 'book_admission_test_fee_page_visit',
  PAYMENT_PAGE_VISIT: 'payment_page_visit',
  BOOK_ADMISSION_TEST_FEE_BACK_BUTTON: 'book_admission_test_fee_back_button',
  PAYMENT_PAGE_BACK_BUTTON: 'payment_page_back_button',
  PAYMENT_APPLY_COUPON: 'payment_apply_coupon',
  PAYMENT_REMOVE_COUPON: 'payment_remove_coupon',
  PAYMENT_CONTINUE: 'payment_continue',
  PAYMENT_CANCELLED: 'payment_cancelled',
  BOOK_ADMISSION_TEST_FEE_SECTION_CLICKED:
    'book_admission_test_fee_section_clicked',
  PAYMENT_PAGE_FAQ_CLICKED: 'payment_page_faq_clicked',
  APPLICATION_FEE_FAQ_SECTION_VIEWED: 'application_fee_faq_section_viewed',

  // Share Payment Link to Parent
  SHARE_PAYMENT_LINK_CLICKED: 'share_payment_link_clicked',
  SHARE_PAYMENT_LINK_POPUP_VIEWED: 'share_payment_link_popup_viewed',
  SHARE_PAYMENT_LINK_WHATSAPP_CLICKED: 'share_payment_link_whatsapp_clicked',
  SHARE_PAYMENT_LINK_COPY_CLICKED: 'share_payment_link_copy_clicked',
  SHARE_PAYMENT_LINK_CLOSE_CLICKED: 'share_payment_link_close_clicked',

  // Payment Success
  BOOK_ADMISSION_TEST_FEE_SUCCESS_PAGE_VISIT:
    'book_admission_test_fee_success_page_visit',
  BOOK_ADMISSION_TEST_FEE_SUCCESS_PAGE_PREVIOUS_BUTTON_CLICKED:
    'book_admission_test_fee_success_page_previous_button_clicked',
  BOOK_ADMISSION_TEST_FEE_SUCCESS_PAGE_CONTINUE_BUTTON_CLICKED:
    'book_admission_test_fee_success_page_continue_button_clicked',

  // Exam Slot Booking
  EXAM_SLOT_SELECTION_PAGE_VISIT: 'exam_slot_selection_page_visit',
  EXAM_SLOT_SELECTION_VISIT: 'exam_slot_selection_visit',
  EXAM_SLOT_SELECTION_PROCEED_CLICKED: 'exam_slot_selection_proceed_clicked',
  EXAM_SLOT_PROCEED: 'exam_slot_proceed',
  EXAM_SLOT_BACK_BUTTON: 'exam_slot_back_button',

  // NAT Exam
  LATER_EXAM_SCHEDULE_SUCCESS_VIEW_EXAM_GUIDE_CLICKED:
    'later_exam_schedule_success_view_exam_guide_clicked',
  ACCESS_NAT_MOCK_EXAM: 'access_nat_mock_exam',
  VIEW_NAT_SAMPLE_REPORT: 'view_nat_sample_report',
  LATER_EXAM_SCHEDULE_SUCCESS_START_EXAM_CLICKED:
    'later_exam_schedule_success_start_exam_clicked',
  LATER_EXAM_SCHEDULE_SUCCESS_VISIT: 'later_exam_schedule_success_visit',
  NAT_EXAM_SECTION_CLICKED: 'nat_exam_section_clicked',

  // NAT Exam - Reschedule
  RESCHEDULE_EXAM_VISIT: 'reschedule_exam_visit',
  RESCHEDULE_EXAM_BUTTON_CLICKED: 'reschedule_exam_button_clicked',
  RESCHEDULE_EXAM_SLOT_SELECTION_PAGE_VISIT:
    'reschedule_exam_slot_selection_page_visit',
  RESCHEDULE_EXAM_SLOT_SELECTION_PROCEED_CLICKED:
    'reschedule_exam_slot_selection_proceed_clicked',
  LATER_EXAM_RESCHEDULE_SUCCESS_VISIT: 'later_exam_reschedule_success_visit',
  LATER_EXAM_RESCHEDULE_SUCCESS_START_EXAM_CLICKED:
    'later_exam_reschedule_success_start_exam_clicked',

  // NAT Exam - Retake
  NIAT_PORTAL_RETAKE_EXAM_PAGE_VISIT: 'niat_portal_retake_exam_page_visit',
  NIAT_PORTAL_RETAKE_EXAM_BUTTON_CLICKED:
    'niat_portal_retake_exam_button_clicked',
  RETAKE_EXAM_SLOT_SELECTION_PAGE_VISIT:
    'retake_exam_slot_selection_page_visit',
  RETAKE_EXAM_SLOT_SELECTION_PROCEED_CLICKED:
    'retake_exam_slot_selection_proceed_clicked',
  RETAKE_EXAM_SUCCESS_VISIT: 'retake_exam_success_visit',
  RETAKE_NAT_START_EXAM_CLICKED: 'retake_nat_start_exam_clicked',

  // NAT Exam - Retake Reschedule
  RETAKE_RESCHEDULE_EXAM_PAGE_VISIT: 'retake_reschedule_exam_page_visit',
  RETAKE_RESCHEDULE_EXAM_BUTTON_CLICKED:
    'retake_reschedule_exam_button_clicked',
  RETAKE_RESCHEDULE_EXAM_SLOT_SELECTION_PAGE_VISIT:
    'retake_reschedule_exam_slot_selection_page_visit',
  RETAKE_RESCHEDULE_EXAM_SLOT_SELECTION_PROCEED_CLICKED:
    'retake_reschedule_exam_slot_selection_proceed_clicked',
  RETAKE_RESCHEDULE_EXAM_SUCCESS_PAGE_VISIT:
    'retake_reschedule_exam_success_page_visit',
  RETAKE_RESCHEDULE_EXAM_START_EXAM_CLICKED:
    'retake_reschedule_exam_start_exam_clicked',

  // Campus Connect Section
  CAMPUS_CONNECT_SECTION_CLICKED: 'campus_connect_section_clicked',
  CAMPUS_VISIT_SCHEDULER_SECTION_VISIT: 'campus_visit_scheduler_section_visit',

  // Application Fee Pay Section
  APPLICATION_FEE_PAY_SECTION_CLICKED: 'application_fee_pay_section_clicked',

  // General/Other
  HELP_AND_SUPPORT_CLICKED: 'help_and_support_clicked',
  PORTAL_LOGOUT: 'portal_logout',
  PORTAL_LOGOUT_CONFIRMATION_SHOWN: 'portal_logout_confirmation_shown',
  PORTAL_LOGOUT_CANCEL_CLICKED: 'portal_logout_cancel_clicked',
  PORTAL_LOGOUT_CONFIRMED: 'portal_logout_confirmed',
  CHECK_EXAM_DETAILS_CLICKED: 'check_exam_details_clicked',
  NIAT_PORTAL_EXAM_PROGRESS_PAGE_VISIT: 'niat_portal_exam_progress_page_visit',

  // NAT Report
  NAT_SAMPLE_REPORT_PAGE_VISITED: 'nat_sample_report_page_visited',
  NAT_SAMPLE_REPORT_APPLY_NOW_CLICKED: 'nat_sample_report_apply_now_clicked',
  NAT_SAMPLE_REPORT_MID_CTA_CLICKED: 'nat_sample_report_mid_cta_clicked',
  NAT_SAMPLE_REPORT_BOTTOM_CTA_CLICKED: 'nat_sample_report_bottom_cta_clicked',
  NAT_EXAM_QUALIFIED_REPORT_BUTTON_CLICKED:
    'nat_exam_qualified_report_button_clicked',
  NAT_REPORT_PAGE_VISITED: 'nat_report_page_visited',
  NAT_REPORT_PAGE_SHARED_VIEW_PAGE_VISITED:
    'nat_report_page_shared_view_page_visited',
  NAT_EXAM_QUALIFIED_SUCCESS_PAGE_VISIT:
    'nat_exam_qualified_success_page_visit',
  NAT_EXAM_QUALIFIED_REPORT_PAGE_VISIT: 'nat_exam_qualified_report_page_visit',
  NAT_EXAM_QUALIFIED_WAITING_PAGE_VISIT_OFFLINE_LEADS:
    'nat_exam_qualified_waiting_page_visit_offline_leads',
  NAT_EXAM_QUALIFIED_WAITING_PAGE_VISIT:
    'nat_exam_qualified_waiting_page_visit',
  NAT_REPORT_PAGE_SHARE_CLICKED: 'nat_report_page_share_clicked',
  NAT_REPORT_PAGE_NEXT_STEPS_CTA_CLICKED_MID:
    'nat_report_page_next_steps_cta_clicked_mid',
  NAT_REPORT_PAGE_NEXT_STEPS_CTA_CLICKED_BOTTOM:
    'nat_report_page_next_steps_cta_clicked_bottom',
  NAT_REPORT_PAGE_CAREERPATH_CLICKED: 'nat_report_page_careerpath_clicked',
  NAT_REPORT_PAGE_SHARED_VIEW_APPLY_NOW_CLICKED:
    'nat_report_page_shared_view_apply_now_clicked',
  NAT_REPORT_PAGE_SHARED_VIEW_MID_CTA_CLICKED:
    'nat_report_page_shared_view_mid_cta_clicked',
  NAT_REPORT_PAGE_SHARED_VIEW_BUTTOM_CTA_CLICKED:
    'nat_report_page_shared_view_buttom_cta_clicked',
  NAT_REPORT_PAGE_SHARED_VIEW_CAREERPATH_CLICKED:
    'nat_report_page_shared_view_careerpath_clicked',

  // Qualified Report Preview
  QUALIFIED_REPORT_PREVIEW_PAGE_VISIT: 'qualified_report_preview_page_visit',
  QUALIFIED_REPORT_PREVIEW_VIEW_REPORT_CLICKED:
    'qualified_report_preview_view_report_clicked',
  QUALIFIED_REPORT_PREVIEW_NEXT_STEP_CTA_CLICKED:
    'qualified_report_preview_next_step_cta_clicked',

  // Invite Code Modal
  NIAT_SELF_INVITECODE_POPUP_VIEWED: 'niat_self_invitecode_popup_viewed',
  NIAT_SELF_INVITECODE_POPUP_CONTINUE_CLICKED:
    'niat_self_invitecode_popup_continue_clicked',

  // Total Time Spent (combines section-specific duration and cumulative session time)
  USER_TOTAL_TIME_SPENT_IN_PAGE_EVENT: 'user_total_time_spent_in_page_event'
} as const;
